import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import icon from './images/app_logo.png';
import logo from '../../assets/images/mysaloonhub_transparent.png';

const CustomeNavbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 60);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const isActive = (path) => location.pathname === path;

    const navLinks = [
        { path: '/', label: 'Home' },
        { path: '/privacy-policy', label: 'Privacy Policy' },
        { path: '/terms-and-conditions', label: 'Terms & Conditions' },
        { path: '/return-and-refund-policy', label: 'Return & Refund Policy' },
    ];

    return (
        <nav 
            className={`navbar ${scrolled ? 'scrolled' : ''}`} 
            id="navbar" 
            style={{ 
                backgroundColor: '#161829', 
                color: 'white', 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                width: '100%', 
                zIndex: 1000,
                transition: 'all 0.3s ease'
            }}
        >
            <div className="container-fluid nav-container ps-4 pe-4 d-flex justify-content-between align-items-center" style={{ height: '70px' }}>
                <Link to="/" className="d-flex align-items-center logo" style={{ textDecoration: 'none' }}>
                    {/* <img src={icon} alt="My Salon Hub Icon" style={{ height: '40px' }} /> */}
                     <img src={logo} alt="My Salon Hub Logo" style={{height:'60px'}}/>
                </Link>

                {/* Desktop Menu */}
                <div className="nav-actions d-none d-lg-flex gap-4" style={{ color: 'white' }}>
                    {navLinks.map((link) => (
                        <Link key={link.path} to={link.path} style={{ textDecoration: 'none' }}>
                            <p className='mb-0' style={{ 
                                color: isActive(link.path) ? '#64dfd4ff' : 'white',
                                transition: 'color 0.2s ease'
                            }}>
                                {link.label}
                            </p>
                        </Link>
                    ))}
                </div>

                {/* Mobile Menu Toggle */}
                <button 
                    className="d-lg-none btn border-0 text-white" 
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    style={{ fontSize: '1.5rem' }}
                >
                    <i className={`fa-solid ${isMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
                </button>
            </div>

            {/* Mobile Menu Dropdown */}
            <div 
                className={`d-lg-none w-100 overflow-hidden`} 
                style={{ 
                    maxHeight: isMenuOpen ? '300px' : '0',
                    transition: 'max-height 0.4s ease-in-out',
                    backgroundColor: '#1a1d30',
                    borderBottom: isMenuOpen ? '1px solid rgba(255,255,255,0.1)' : 'none'
                }}
            >
                <div className="d-flex flex-column p-4 gap-3">
                    {navLinks.map((link) => (
                        <Link 
                            key={link.path} 
                            to={link.path} 
                            style={{ textDecoration: 'none' }}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            <p className='mb-0' style={{ 
                                color: isActive(link.path) ? '#64dfd4ff' : 'white',
                                fontSize: '1.1rem'
                            }}>
                                {link.label}
                            </p>
                        </Link>
                    ))}
                </div>
            </div>
        </nav>
    );
};

export default CustomeNavbar;
